// Intelligence Report API client — the holistic report endpoints (`/intel-reports`).
//
// The per-module calls are NOT here: the Create wizard's steps 1–3 drive the existing Competitive
// Intel endpoints through their own module (CompetitiveIntel/); step 4 submits the report here.
//
// Same thin promise wrappers as Audits/campaignAuditsApi.js; `API_HOST` already supplies /api/v1,
// and arClient adds the Bearer token + tenant headers. Per-layer retry has no backend route yet —
// it gets added here once the backend shares it.

import arClient from '../../util/api_client';

export const INTEL_REPORTS_ENDPOINT = '/intel-reports';

const apiGet = (endpoint, options = {}) =>
  new Promise((resolve) => arClient.doApiCallGet(endpoint, resolve, options));

const apiPost = (endpoint, body = {}, options = {}) =>
  new Promise((resolve) => arClient.doApiCallV2(endpoint, body, resolve, options));

// doApiCallV2 hardcodes POST; only doApiCall honours options.method.
const apiDelete = (endpoint) =>
  new Promise((resolve) =>
    arClient.doApiCall(endpoint, {}, resolve, undefined, { method: 'DELETE' })
  );

/**
 * GET /intel-reports — every intelligence report in the workspace (holistic: one row per product).
 * Response: { status, message, data: [{ id, productName, productURL, audienceReport: { status },
 * culturalReport: { status }, competitiveReport: { status }, createdBy, createdAt }] }.
 */
export const listIntelReports = () => apiGet(INTEL_REPORTS_ENDPOINT);

/**
 * POST /intel-reports — create the report from the wizard (JSON body).
 * @param {{
 *   productName: string, productURL: string, documentS3URLs: string[],
 *   productClass?: string, additionalContext?: string, objective?: string,
 *   platforms?: string[], competitorList?: string[], competitiveIntelRequestId: number
 * }} payload
 */
export const createIntelReport = (payload) => apiPost(INTEL_REPORTS_ENDPOINT, payload);

/**
 * POST /classify-url — whether a page is a brand, a product category or a single product. A model
 * opens the page, so it takes 3–8s; nothing is stored, so a lost response is never re-sent.
 * Response data: { url, label: 'brand' | 'product_category' | 'product', name, probabilities, rationale }.
 */
export const classifyUrl = (url) =>
  apiPost('/classify-url', { url }, { timeout: 30000, noRetry: true });

/** DELETE /intel-reports/{id} — permanently delete a report. */
export const deleteIntelReport = (id) =>
  apiDelete(`${INTEL_REPORTS_ENDPOINT}/${encodeURIComponent(id)}`);
